import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import LocalizedLink from "@/components/LocalizedLink.vue";
import i18n from "@/i18n";

export default {
  name: "Navbar",
  props: {

  },
  data() {
    var navbar = i18n.t("navbar");
    return {
      locale : this.$route.params.locale,
      hover: false,
      scrollPosition: null,
      changeNavBar: false,
      navbar: navbar,
      
      tabs: ['en', 'it','es']
    };
  },
  computed: {
  	
  },
  mounted() {
  },

  created: function () {
   },
  components: {LocaleSwitcher, LocalizedLink},
  methods: {
    changeLocale(locale, e) {
      if(this.locale != locale) {
        if(this.$route.path.includes("/"+this.locale+"/")) {
          this.$router.push(this.$route.path.replace(`/${this.locale}/`, `/${locale}/`));
        } else {
          this.$router.push(this.$route.path.replace(`/${this.locale}`, `/${locale}`));
        }

        this.locale = locale;
        i18n.locale = locale;
        this.$store.commit('setActiveLocale', this.locale);
        location.reload();
      }
    },
  }

};
